export class Site {
    public id: number;
    public name: string;
    public code: string;
    public color: string;
}

export interface IExternalLink {
    name: string;
    link: string;
}

/**
 * Model to hold an array of site settings from the core db
 */
export class SiteSettings {
    public site: Site;
    public logoUrl: string;
    public coreSiteUrl: string;
    public privacyUrl: string;
    public contactUrl: string;
    public faqUrl: string;
    public careersUrl: string;
    public advertiseUrl: string;
    public floSportsUrl: string;
    public termsOfUseUrl: string;
    public adminUrl: string;
    public facebookPageUrl: string;
    public twitterPageUrl: string;
    public instagramPageUrl: string;
    public youtubePageUrl: string;
    public maxHeaderLinkCount: number;
    public customNav: string[];
    public externalLinks: IExternalLink[];

    public deserialize(json: any): SiteSettings {
        const data: any = json['data'] || json;

        this.site = new Site();
        this.site.id = data.site.id;
        this.site.name = data.site.name;
        this.site.color = data.site.color;
        this.site.code = data.site.code;

        this.contactUrl = data.contact_url;
        this.faqUrl = data.faq_url;
        this.careersUrl = data.careers_url;
        this.advertiseUrl = data.advertise_url;
        this.coreSiteUrl = data.core_site_url;
        this.floSportsUrl = data.flosports_url;
        this.termsOfUseUrl = data.tos_url;
        this.logoUrl = data.logo_url;
        this.adminUrl = data.admin_url;
        this.facebookPageUrl = data.facebook_page_url;
        this.twitterPageUrl = data.twitter_page_url;
        this.instagramPageUrl = data.instagram_page_url;
        this.youtubePageUrl = data.youtube_page_url;
        this.maxHeaderLinkCount = data.max_header_link_count || 4;
        this.customNav = data.custom_nav || [];
        this.externalLinks = [];

        if (data.external_links) {
            data.external_links.forEach((el: any) => {
                for (const key in el) {
                    if (el.hasOwnProperty(key)) {
                        this.externalLinks.push({ name: key, link: el[key] });
                    }
                }
            });
        }

        return this;
    }
}
